export default {
	featureFlags: {
		DEMAND_9230_RESET_ORDERS_INFO_EDIT_PAGE: false,
		LLP_18517_NON_BARCODE_DELIVERY: true,
		LLP_24216_DRIVER_PAYMENT_REPORT_PHASE_2: true
	}
}
